import SlugifyCore from "slugify";
import MustacheCore from "mustache";

function Slugify(value) {
  if (typeof value !== "string") return "";
  return SlugifyCore(value, {
    remove: /[*+~.()'"!:@–]/g,
    lower: true,
  });
}

function Mustache(a, b) {
  return MustacheCore.render(a, b);
}

function ScrollTo(selector) {
  const target = document.querySelector(selector);
  if (!target) return;
  target.scrollIntoView({ behavior: "smooth" });
}

export { Slugify, Mustache, ScrollTo };
